/**
 * Coverax Global Menu – Interaktion (Vorlage global-menu.js + JSON-Render)
 */
(function () {
    'use strict';

    const VISUAL_AID_KEY = 'gmenu-visual-aid';

    function syncVisualAidButtons(on) {
        document.querySelectorAll('[data-gmenu-visual-aid]').forEach((btn) => {
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
    }

    function applyVisualAid(on) {
        document.documentElement.classList.toggle('gmenu-visual-aid', on);
        syncVisualAidButtons(on);
    }

    let visualAidOn = false;
    try {
        visualAidOn = localStorage.getItem(VISUAL_AID_KEY) === '1';
    } catch (e) {}
    applyVisualAid(visualAidOn);

    if (!window.__coveraxVisualAidBound) {
        window.__coveraxVisualAidBound = true;
        document.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-gmenu-visual-aid]');
            if (!btn) return;
            visualAidOn = !document.documentElement.classList.contains('gmenu-visual-aid');
            applyVisualAid(visualAidOn);
            try {
                localStorage.setItem(VISUAL_AID_KEY, visualAidOn ? '1' : '0');
            } catch (err) {}
        });
    }

    /* Menübilder (data-gmenu-src) erst nach dem Laden der Seite oder beim Öffnen des Menüs laden */
    window.coveraxGmenuHydrate = function () {
        window.__coveraxGmenuImgsReady = true;
        document.querySelectorAll('[data-gmenu-src],[data-gmenu-srcset]').forEach((el) => {
            const srcset = el.getAttribute('data-gmenu-srcset');
            const src = el.getAttribute('data-gmenu-src');
            if (srcset) el.setAttribute('srcset', srcset);
            if (src) el.setAttribute('src', src);
            el.removeAttribute('data-gmenu-srcset');
            el.removeAttribute('data-gmenu-src');
        });
    };

    (function scheduleHydrate() {
        const run = () => {
            const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
            idle(window.coveraxGmenuHydrate, { timeout: 3000 });
        };
        if (document.readyState === 'complete') run();
        else window.addEventListener('load', run, { once: true });
    })();

    if (window.__coveraxGmenuBooted) return;

    const menu = document.getElementById('global-menu');
    const toggle = document.getElementById('global-menu-toggle');
    if (!menu || !toggle) return;

    window.__coveraxGmenuBooted = true;

    let closeButtons = [];
    let tabButtons = [];
    let modeButtons = [];
    let unifiedButtons = [];
    let modePanes = [];
    let views = [];

    let lastFocus = null;
    let scrollRaf = null;
    let resizeTimer = null;
    let bodyScrollY = 0;
    let activeTabId = menu.dataset.gmenuDefaultTab || 'marken';
    let activeMode = 'page';
    let eventsBound = false;
    let pushCloseTimer = null;
    const canvas = document.getElementById('page-canvas');

    function refreshElements() {
        closeButtons = menu.querySelectorAll('[data-gmenu-close]');
        tabButtons = menu.querySelectorAll('[data-gmenu-tab]');
        modeButtons = menu.querySelectorAll('[data-gmenu-mode]:not([data-gmenu-unified])');
        unifiedButtons = menu.querySelectorAll('[data-gmenu-unified]');
        modePanes = menu.querySelectorAll('.gmenu__mobile-pane');
        views = menu.querySelectorAll('.gmenu__view');
        activeTabId = menu.dataset.gmenuDefaultTab || tabButtons[0]?.dataset.gmenuTab || activeTabId;
    }

    function isMobileMenu() {
        return window.matchMedia('(max-width: 768px)').matches;
    }

    function syncUnifiedTabs() {
        unifiedButtons.forEach((btn) => {
            const isPage = btn.dataset.gmenuMode === 'page';
            const tabId = btn.dataset.gmenuTab;
            const active = isPage
                ? activeMode === 'page'
                : activeMode === 'global' && tabId === activeTabId;

            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (!isMobileMenu()) return;

        const activeUnified = menu.querySelector('[data-gmenu-unified].is-active');
        activeUnified?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    function applyMode() {
        const mobile = isMobileMenu();

        modeButtons.forEach((btn) => {
            const active = mobile && btn.dataset.gmenuMode === activeMode;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-selected', active ? 'true' : 'false');
            btn.tabIndex = mobile ? 0 : -1;
        });

        modePanes.forEach((pane) => {
            const isPage = pane.classList.contains('gmenu__mobile-pane--page');
            const isGlobal = pane.classList.contains('gmenu__mobile-pane--global');
            const active = !mobile || (activeMode === 'page' && isPage) || (activeMode === 'global' && isGlobal);

            pane.classList.toggle('is-active', active);
            pane.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        syncUnifiedTabs();
    }

    function switchMode(mode) {
        if (!isMobileMenu() || activeMode === mode) return;

        activeMode = mode;
        applyMode();

        if (mode === 'global') {
            switchTab(activeTabId);
            scheduleScrollButtonUpdate();
        }
    }

    function activateUnified(btn) {
        if (btn.dataset.gmenuMode === 'page') {
            switchMode('page');
            btn.focus();
            return;
        }

        const tabId = btn.dataset.gmenuTab;
        if (!tabId) return;

        activeMode = 'global';
        applyMode();
        switchTab(tabId);
        btn.focus();
    }

    function teleportMenu() {
        if (!canvas || menu.parentElement === document.body) return;
        document.body.insertBefore(menu, canvas);
    }

    function clearPushCloseTimer() {
        if (!pushCloseTimer) return;
        clearTimeout(pushCloseTimer);
        pushCloseTimer = null;
    }

    function resetMobilePanels() {
        const root = menu.querySelector('.gmenu-mnav');
        if (!root) return;
        root.classList.remove('is-drilled');
        root.querySelectorAll('.gmenu-mnav__panel').forEach((panel) => {
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
        });
    }

    function openMobilePanel(panel) {
        if (!panel) return;
        const root = panel.closest('.gmenu-mnav');
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        root?.classList.add('is-drilled');
        panel.querySelector('[data-gmenu-panel-back]')?.focus();
    }

    function closeMobilePanel(panel) {
        if (!panel) return;
        const root = panel.closest('.gmenu-mnav');
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        const stillOpen = root?.querySelector('.gmenu-mnav__panel.is-open');
        if (!stillOpen) {
            root?.classList.remove('is-drilled');
        }
    }

    function resetPushCanvas() {
        if (!canvas) return;
        canvas.classList.remove('is-pushed', 'is-frozen', 'is-closing');
        document.body.classList.remove('gmenu-push-open');
        document.body.style.removeProperty('--gmenu-scroll-y');
    }

    function unlockBody() {
        document.body.classList.remove('gmenu-body-lock');
        document.body.style.top = '';
        document.getElementById('header')?.classList.remove('header--scroll-frozen');
        window.scrollTo(0, bodyScrollY);
    }

    function releasePushLayout() {
        if (canvas) {
            canvas.style.transition = 'none';
        }
        resetPushCanvas();
        unlockBody();
        if (canvas) {
            requestAnimationFrame(() => {
                canvas.style.removeProperty('transition');
            });
        }
    }

    function openMenu() {
        window.coveraxGmenuHydrate();
        lastFocus = document.activeElement;
        bodyScrollY = window.scrollY;
        document.body.style.setProperty('--gmenu-scroll-y', `${bodyScrollY}px`);
        clearPushCloseTimer();
        teleportMenu();

        menu.classList.add('gmenu--open');
        if (isDesignMode()) {
            menu.classList.add('gmenu--editor-open');
        }
        resetMobilePanels();
        menu.setAttribute('aria-hidden', 'false');
        toggle.classList.add('gmenu-toggle--open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', toggle.dataset.gmenuLabelClose || 'Menü schließen');
        document.body.classList.add('gmenu-body-lock');
        const headerEl = document.getElementById('header');
        if (headerEl && !window.matchMedia('(max-width: 768px)').matches) {
            if (bodyScrollY > 20) {
                headerEl.classList.add('header--scrolled');
                headerEl.classList.add('header--scroll-frozen');
            }
        }

        if (canvas) {
            document.body.classList.add('gmenu-push-open');
            canvas.classList.add('is-frozen');
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (menu.classList.contains('gmenu--open')) {
                        canvas.classList.add('is-pushed');
                    }
                });
            });
        } else {
            document.body.style.top = `-${bodyScrollY}px`;
        }

        if (isMobileMenu()) {
            activeMode = 'page';
        }

        applyMode();
        switchTab(activeTabId);

        const focusTarget = menu.querySelector('.gmenu-mnav a, .gmenu-mnav button, [data-gmenu-unified]');

        focusTarget?.focus({ preventScroll: true });
        scheduleScrollButtonUpdate();
    }

    function closeMenu() {
        if (!menu.classList.contains('gmenu--open')) return;

        const wasPush = document.body.classList.contains('gmenu-push-open');

        menu.classList.remove('gmenu--open', 'gmenu--editor-open');
        menu.setAttribute('aria-hidden', 'true');
        toggle.classList.remove('gmenu-toggle--open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', toggle.dataset.gmenuLabelOpen || 'Menü');
        resetMobilePanels();

        if (wasPush && canvas) {
            canvas.style.transition = 'none';
            canvas.classList.add('is-closing');
            void canvas.offsetWidth;
            canvas.style.removeProperty('transition');
            canvas.classList.remove('is-pushed');
            clearPushCloseTimer();

            let finished = false;
            const finish = () => {
                if (finished) return;
                finished = true;
                canvas.removeEventListener('transitionend', onEnd);
                clearPushCloseTimer();
                releasePushLayout();
                if (lastFocus) lastFocus.focus();
            };

            const onEnd = (event) => {
                if (event.target !== canvas) return;
                if (event.propertyName && event.propertyName !== 'transform') return;
                finish();
            };

            canvas.addEventListener('transitionend', onEnd);
            pushCloseTimer = setTimeout(finish, 480);
            return;
        }

        unlockBody();
        if (lastFocus) lastFocus.focus();
    }

    function switchTab(tabId) {
        if (!tabId) return;

        activeTabId = tabId;

        tabButtons.forEach((btn) => {
            const active = btn.dataset.gmenuTab === tabId;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-selected', active ? 'true' : 'false');

            if (active && isMobileMenu() && !menu.querySelector('.gmenu__unified-nav')) {
                btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        });

        views.forEach((view) => {
            const active = view.id === 'gmenu-panel-' + tabId;
            view.classList.toggle('is-active', active);
            view.hidden = !active;
        });

        syncUnifiedTabs();
        scheduleScrollButtonUpdate();
    }

    function updateScrollButtons() {
        if (isMobileMenu()) return;

        menu.querySelectorAll('.gmenu__track-wrap').forEach((wrap) => {
            const track = wrap.querySelector('.gmenu__track');
            const nextBtn = wrap.querySelector('[data-gmenu-scroll="next"]');
            if (!track || !nextBtn) return;

            const canScroll = track.scrollWidth > track.clientWidth + 4;
            const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
            nextBtn.hidden = !canScroll || atEnd;
        });
    }

    function scheduleScrollButtonUpdate() {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(() => {
            scrollRaf = null;
            updateScrollButtons();
        });
    }

    function bindBestsellerRowScroll() {
        menu.querySelectorAll('.gmenu-mnav__circles').forEach((track) => {
            if (track.dataset.gmenuCircleBound === '1') return;
            track.dataset.gmenuCircleBound = '1';

            track.addEventListener('wheel', (event) => {
                if (track.scrollWidth <= track.clientWidth + 2) return;

                const delta = Math.abs(event.deltaY) > Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
                if (!delta) return;

                const max = track.scrollWidth - track.clientWidth;
                const next = track.scrollLeft + delta;
                if ((delta < 0 && track.scrollLeft <= 0) || (delta > 0 && track.scrollLeft >= max - 1)) {
                    return;
                }

                event.preventDefault();
                track.scrollLeft = Math.max(0, Math.min(max, next));
            }, { passive: false });
        });
    }

    function bindEvents() {
        if (eventsBound) return;
        eventsBound = true;
        bindBestsellerRowScroll();

        toggle.addEventListener('click', (event) => {
            event.stopPropagation();
            menu.classList.contains('gmenu--open') ? closeMenu() : openMenu();
        });

        canvas?.addEventListener('click', () => {
            if (menu.classList.contains('gmenu--open')) {
                closeMenu();
            }
        });

        let swipeStartX = 0;
        let swipeStartY = 0;
        let swipeTracking = false;
        let swipeClosed = false;

        function swipeStripLeft() {
            return window.innerWidth * 0.76;
        }

        function canSwipeClose() {
            return isMobileMenu() && menu.classList.contains('gmenu--open');
        }

        function beginSwipeXY(x, y) {
            if (!canSwipeClose() || x < swipeStripLeft()) {
                swipeTracking = false;
                return;
            }
            swipeTracking = true;
            swipeClosed = false;
            swipeStartX = x;
            swipeStartY = y;
        }

        function moveSwipe(x, y) {
            if (!swipeTracking || swipeClosed || !canSwipeClose()) return;
            const dx = x - swipeStartX;
            const dy = y - swipeStartY;
            if (Math.abs(dy) > 72 && Math.abs(dy) > Math.abs(dx)) {
                swipeTracking = false;
                return;
            }
            if (dx <= -28 && Math.abs(dx) >= Math.abs(dy) * 0.55) {
                swipeClosed = true;
                swipeTracking = false;
                closeMenu();
            }
        }

        function endSwipe(x, y) {
            if (swipeTracking && !swipeClosed) {
                moveSwipe(x, y);
            }
            swipeTracking = false;
        }

        document.addEventListener('touchstart', (e) => {
            const t = e.changedTouches[0];
            if (t) beginSwipeXY(t.clientX, t.clientY);
        }, { passive: true, capture: true });

        document.addEventListener('touchmove', (e) => {
            const t = e.changedTouches[0];
            if (t) moveSwipe(t.clientX, t.clientY);
        }, { passive: true, capture: true });

        document.addEventListener('touchend', (e) => {
            const t = e.changedTouches[0];
            if (t) endSwipe(t.clientX, t.clientY);
            else swipeTracking = false;
        }, { passive: true, capture: true });

        document.addEventListener('touchcancel', () => {
            swipeTracking = false;
        }, { passive: true, capture: true });

        document.addEventListener('pointerdown', (e) => {
            if (e.pointerType === 'touch') return;
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            beginSwipeXY(e.clientX, e.clientY);
        }, { passive: true, capture: true });

        document.addEventListener('pointermove', (e) => {
            if (e.pointerType === 'touch') return;
            moveSwipe(e.clientX, e.clientY);
        }, { passive: true, capture: true });

        document.addEventListener('pointerup', (e) => {
            if (e.pointerType === 'touch') return;
            endSwipe(e.clientX, e.clientY);
        }, { passive: true, capture: true });

        closeButtons.forEach((btn) => btn.addEventListener('click', closeMenu));

        menu.querySelector('.gmenu__overlay')?.addEventListener('click', closeMenu);

        document.addEventListener('click', (e) => {
            const link = e.target.closest('[data-gmenu-close-link]');
            if (link && menu.classList.contains('gmenu--open')) {
                closeMenu();
            }
        });

        menu.addEventListener('change', (e) => {
            const select = e.target.closest('[data-gmenu-locale]');
            if (select && select.form) {
                select.form.submit();
            }
        });

        menu.querySelector('.gmenu__mode-tabs')?.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-gmenu-mode]');
            if (!btn) return;
            e.preventDefault();
            switchMode(btn.dataset.gmenuMode);
            btn.focus();
        });

        menu.querySelector('.gmenu__unified-nav')?.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-gmenu-unified]');
            if (!btn) return;
            e.preventDefault();
            activateUnified(btn);
        });

        menu.querySelector('.gmenu__sidebar')?.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-gmenu-tab]');
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            switchTab(btn.dataset.gmenuTab);
        });

        menu.addEventListener('click', (e) => {
            const openBtn = e.target.closest('[data-gmenu-panel-open]');
            if (openBtn && menu.contains(openBtn)) {
                e.preventDefault();
                const panel = document.getElementById(openBtn.getAttribute('data-gmenu-panel-open'));
                openMobilePanel(panel);
                return;
            }

            const backBtn = e.target.closest('[data-gmenu-panel-back]');
            if (backBtn && menu.contains(backBtn)) {
                e.preventDefault();
                closeMobilePanel(backBtn.closest('.gmenu-mnav__panel'));
                return;
            }

            const btn = e.target.closest('[data-gmenu-scroll="next"]');
            if (!btn) return;

            const track = btn.closest('.gmenu__track-wrap')?.querySelector('.gmenu__track');
            if (!track) return;

            if ('onscrollend' in window) {
                track.addEventListener('scrollend', () => updateScrollButtons(), { once: true });
            } else {
                setTimeout(updateScrollButtons, 300);
            }

            track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
        });

        menu.addEventListener('scroll', (e) => {
            if (e.target.classList?.contains('gmenu__track')) {
                scheduleScrollButtonUpdate();
            }
        }, true);

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && menu.classList.contains('gmenu--open')) {
                closeMenu();
            }
        });

        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                applyMode();
                updateScrollButtons();
            }, 150);
        }, { passive: true });
    }

    function init() {
        teleportMenu();
        refreshElements();
        applyMode();
        if (activeTabId) switchTab(activeTabId);
        bindEvents();
        scheduleScrollButtonUpdate();
        syncVisualAidButtons(document.documentElement.classList.contains('gmenu-visual-aid'));
    }

    function reinit() {
        teleportMenu();
        refreshElements();
        applyMode();
        if (activeTabId) switchTab(activeTabId);
        bindBestsellerRowScroll();
        scheduleScrollButtonUpdate();
    }

    function hasLiquidContent() {
        if (menu.dataset.gmenuSource === 'liquid') return true;
        const viewsRoot = document.getElementById('gmenu-main-views');
        return Boolean(viewsRoot && viewsRoot.children.length);
    }

    function isDesignMode() {
        return document.documentElement.classList.contains('shopify-design-mode');
    }

    function isGlobalMenuSection(sectionId) {
        return typeof sectionId === 'string' && sectionId.includes('coverax-global-menu');
    }

    function openMenuForEditor() {
        menu.classList.add('gmenu--editor-open');
        if (!menu.classList.contains('gmenu--open')) {
            openMenu();
        }
    }

    function closeMenuForEditor() {
        menu.classList.remove('gmenu--editor-open');
        if (menu.classList.contains('gmenu--open')) {
            closeMenu();
        }
    }

    function initDesignMode() {
        if (!isDesignMode()) return;

        document.addEventListener('shopify:section:select', (event) => {
            if (isGlobalMenuSection(event.detail?.sectionId)) {
                openMenuForEditor();
            }
        });

        document.addEventListener('shopify:section:deselect', (event) => {
            if (isGlobalMenuSection(event.detail?.sectionId)) {
                closeMenuForEditor();
            }
        });

        document.addEventListener('shopify:section:load', (event) => {
            if (isGlobalMenuSection(event.detail?.sectionId)) {
                reinit();
                openMenuForEditor();
            }
        });

        document.addEventListener('shopify:block:select', () => {
            if (menu.classList.contains('gmenu--editor-open') && !menu.classList.contains('gmenu--open')) {
                openMenu();
            }
        });
    }

    function boot() {
        if (hasLiquidContent()) {
            menu.classList.add('gmenu--ready');
            init();
            return;
        }

        const render = typeof window.coveraxGmenuRender === 'function'
            ? window.coveraxGmenuRender()
            : Promise.resolve();

        render
            .catch((error) => {
                console.warn('Coverax Global Menu: Render fehlgeschlagen', error);
            })
            .finally(init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            boot();
            initDesignMode();
        });
    } else {
        boot();
        initDesignMode();
    }
})();
